import { format } from '@rental/i18n'
import { useLocale } from '../i18n'
import { romeDay } from './privacy'

/**
 * S8: what an erasure leaves on a record, said the same way wherever it is
 * read: a detail gone says when, never "not given"; an anonymised customer
 * says what went, what the law keeps, and who may still open what names them.
 */

/** A detail erased: its day, in place of the value. */
export function ErasedOn({ at }: { at: string }) {
  const { locale, messages: m } = useLocale()
  return (
    <span className="text-text-muted">
      {format(m.customer.erasedOn, { date: romeDay(locale, at) })}
    </span>
  )
}

/** An anonymised customer: what went and when, and what the law keeps (no date is set for it). */
export function AnonymisedNote({ anonymisedAt }: { anonymisedAt: string }) {
  const { locale, messages: m } = useLocale()
  const copy = m.customer.remains
  return (
    <>
      <p>{format(copy.erased, { date: romeDay(locale, anonymisedAt) })}</p>
      <p>{copy.keptByLaw}</p>
      <p>{copy.ownerOnly}</p>
    </>
  )
}
